import { imageFragment } from './get-product-query'
import { metafieldFragment } from './utils'

const getProductsByVariantIdQuery = /* GraphQL */ `
	query getProductsByVariantId($productVariants: [ID!]!) {
		nodes(ids: $productVariants) {
			... on ProductVariant {
				title
				availableForSale
				quantityAvailable
				weight
				weightUnit
				price {
					amount
					currencyCode
				}
				id
				image {
					...imageFields
				}
				fullSizeVariantId: metafield(namespace: "productvariant", key: "fz_variant_id") {
					value
				}
				product {
					vendor
					handle
					isProductAvailableForSale: availableForSale
					planDetails: metafield(namespace: "bb_subscriptions_api", key: "plan_details") {
					...metafield
					}
					productId: id
					description
					howToUse: metafield(namespace: "product", key: "how_to_use") {
						...metafield
					}
					avgRating: metafield(namespace: "loox", key: "avg_rating") {
						value
					}
					numReviews: metafield(namespace: "loox", key: "num_reviews") {
						value
					}
				}
			}
		}
	}
	${imageFragment}
	${metafieldFragment}
`
export default getProductsByVariantIdQuery
